import React, { useEffect, useRef, useState } from 'react';
import { useLanguage } from '../../i18n/LanguageContext';

const LanguageSwitcher = () => {
  const { locale, setLocale } = useLanguage();
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  useEffect(() => {
    const onClickOutside = (event) => {
      if (rootRef.current && !rootRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener('click', onClickOutside);
    return () => document.removeEventListener('click', onClickOutside);
  }, []);

  const selectLocale = (value) => {
    setLocale(value);
    setOpen(false);
  };

  return (
    <li
      className={`lang-parent${open ? ' open_add_class' : ''}`}
      ref={rootRef}
    >
      <button
        type="button"
        className="hidden-xs rs-search lang-trigger"
        aria-label="Change language"
        aria-expanded={open}
        onClick={() => setOpen((current) => !current)}
      >
        <i className="fi fi-rr-globe" aria-hidden="true" />
      </button>
      <div className="lang-menu">
        <button
          type="button"
          className={locale === 'en' ? 'is-active' : undefined}
          onClick={() => selectLocale('en')}
        >
          English
        </button>
        <button
          type="button"
          className={locale === 'ar' ? 'is-active' : undefined}
          onClick={() => selectLocale('ar')}
        >
          Arabic
        </button>
      </div>
    </li>
  );
};

export default LanguageSwitcher;
